<template>
  <div>
    <Subheader title="Sign Up" />

    <div class="app-content-column">
      <div class="card">
        <h4>Thank you for investing in the Mzingo Partners community.</h4>

        <!-- LOGIN PAGE -->
        <div v-if="showLoginPage">
          <h6>Welcome back.</h6>

          <form class="form" @submit.stop.prevent="handleLoginFormSubmit">
            <FormError v-if="showFormErrors" :form-errors="formErrors" />

            <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="username">
              <input
                v-model="loginData.username"
                type="text"
                placeholder="Username"
                autocomplete="username"
                autocorrect="off"
                autocapitalize="none"
                required
              />
            </Field>

            <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="password">
              <input
                v-model="loginData.password"
                type="password"
                placeholder="Password"
                autocomplete="current-password"
                autocorrect="off"
                autocapitalize="none"
                required
              />
            </Field>

            <div class="button-wrapper is-centered">
              <button type="submit" class="large-button">
                Login
              </button>
            </div>

            <div class="row" style="text-align: center; margin-top: 1.5rem;">
              <h5 @click="toggleLoginPanel">Sign Up</h5>
            </div>
            <div class="row" style="text-align: center; margin-top: 1.5rem;">
              <router-link :to="{ name: 'ForgotPassword' }">
                <p>Forgot your Password?</p>
              </router-link>
            </div>
          </form>
        </div>

        <!-- SIGN UP PAGE  -->
        <div v-if="!showLoginPage">
          <h6>Let's you signed up for our community.</h6>

          <form class="form" @submit.stop.prevent="registerUser">
            <FormError v-if="showFormErrors" :form-errors="formErrors" />

            <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="firstName">
              <input
                v-model="userData.firstName"
                type="text"
                placeholder="First Name"
                autocomplete="given-name"
                required
              />
            </Field>

            <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="lastName">
              <input
                v-model="userData.lastName"
                type="text"
                placeholder="Last Name"
                autocomplete="family-name"
                required
              />
            </Field>

            <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="username">
              <input
                v-model="userData.username"
                type="text"
                placeholder="Username"
                autocomplete="username"
                required
              />
            </Field>

            <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="email">
              <input
                v-model="userData.email"
                type="text"
                placeholder="Email"
                autocomplete="email"
                required
              />
            </Field>

            <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="password">
              <input
                v-model="userData.password"
                type="password"
                placeholder="Password"
                autocomplete="new-password"
                required
              />
            </Field>

            <div class="button-wrapper is-centered">
              <button type="submit" class="large-button" :disabled="loading">
                Next
              </button>
            </div>

            <div class="row" style="text-align: center; margin-top: 1.5rem;">
              <h5 @click="toggleLoginPanel">Log In</h5>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Subheader from '@/components/Subheader'
import Field from '@/components/Field'

import FormError from '@/components/FormError'
import { validateInputLength } from '@/services/forms'
import User from '@/services/users'

export default {
  name: 'PaymentSignUp',
  components: {
    Subheader,
    Field,
    FormError,
  },
  data() {
    return {
      loading: false,
      showLoginPage: false,
      userData: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        username: '',
        isMaker: true,
      },
      loginData: {
        password: '',
        username: '',
      },

      //field errors are from client-side validation
      fieldErrors: [],
      showFieldErrors: false,
      //form errors are from server-side validation
      formErrors: [],
      showFormErrors: false,

      paymentMethods: [],
      defaultPaymentMethod: null,
      showNewCardPanel: false,
      selectedPaymentMethod: {},
      goalId: null,
      amount: null,
      goal: {},
    }
  },
  computed: {},
  created() {
    // NRS 8.29.19 - TODO: Update this so the goalId and amount are not passed in through the query params. I passed them in
    // as props but they were not persisting when the page refreshed, which threw an error. So this was a quick fix.
    this.goalId = this.$route.params.goalId
    this.amount = this.$route.params.amount
  },
  methods: {
    toggleLoginPanel() {
      this.showLoginPage = !this.showLoginPage
    },
    async registerUser() {
      this.loading = true
      this.fieldErrors = this.collectFieldErrors(this.userData)

      if (this.fieldErrors.length) {
        this.showFieldErrors = true
      } else {
        try {
          const response = await User.api.create(this.userData)
          this.$store.commit('UPDATE_USER', response.user)
          this.$store.commit('UPDATE_USER_TOKEN', response.token)
          this.$router.push({ name: 'PaymentSetup' })
        } catch (error) {
          const { response } = error
          if (response && response.data) {
            this.formErrors = response.data
            this.showFormErrors = true
          }
          this.loading = false
          return
        }
      }
      this.loading = false
    },
    async handleLoginFormSubmit() {
      this.loading = true
      this.fieldErrors = this.collectFieldErrors(this.loginData)

      if (this.fieldErrors.length) {
        this.showFieldErrors = true
      } else {
        try {
          const response = await User.api.login(this.loginData.username, this.loginData.password)
          this.$store.commit('UPDATE_USER', response.user)
          this.$store.commit('UPDATE_USER_TOKEN', response.token)
          this.loading = false
          this.$router.push({ name: 'PaymentSetup' })
        } catch (error) {
          const { response } = error
          if (response && response.data) {
            this.formErrors = response.data
            this.showFormErrors = true
          }
          this.loading = false
          return
        }
      }
    },
    collectFieldErrors(objectToValidate) {
      const errors = []
      Object.keys(objectToValidate).forEach(field => {
        const error = validateInputLength(field, objectToValidate[field])
        if (error) {
          errors.push(error)
        }
      })
      return errors
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/cards';
@import '../styles/mixins/buttons';
@import '../styles/forms';
@import '../styles/layout';

.card {
  @include card-w-borders();
}

.row h5 {
  cursor: pointer;
}
</style>
